function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcnAirflow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 135",
    d: "M26 19.47a6.32 6.32 0 0 0 6.36-5.34 6.17 6.17 0 1 0-12.22-1.69.56.56 0 0 1-.55.45h-.09a.54.54 0 0 1-.45-.6A7.26 7.26 0 0 1 26.2 6.1a4.34 4.34 0 0 1 .51 0 7.22 7.22 0 0 1 6.71 7.69 7.43 7.43 0 0 1-7.49 6.73H7.1a.53.53 0 0 1 0-1.06H26M17.49 29a.53.53 0 0 0-.54.52.27.27 0 0 0 0 .09 5.3 5.3 0 0 0 6.22 4.17 5.23 5.23 0 0 0 3.39-2.24 5.3 5.3 0 0 0-4.38-8.27H7.1a.53.53 0 1 0 0 1.06h15.08a4.23 4.23 0 0 1 4.24 4.24 4.15 4.15 0 0 1-.12 1 4.24 4.24 0 0 1-8.3-.09.54.54 0 0 0-.5-.48M7.17 15.5a.54.54 0 0 0 0 1.07h5.22a4 4 0 0 0 4.05-3.51 3.88 3.88 0 0 0-7.57-1.48.53.53 0 0 0 .35.67.55.55 0 0 0 .18 0 .53.53 0 0 0 .56-.4A2.81 2.81 0 0 1 13.5 10a2.84 2.84 0 0 1 1.95 3 2.9 2.9 0 0 1-3 2.54z",
    style: {
      fill: "#5e5e5d"
    }
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnAirflow);
export default __webpack_public_path__ + "static/media/icn-airflow.cafe4d90ba490500ecaf001bbf79457b.svg";
export { ForwardRef as ReactComponent };